import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useAttributeAndQsContext } from '../contexts/AttributeAndQsContext';
import { getTextByProduct } from '../services/productMeta';

const Header = () => {
  const intl = useIntl();
  const { type } = useAttributeAndQsContext();
  const { nameKey, descriptionKey } = getTextByProduct(type);
  return (
    <Helmet>
      <title>
        {intl.formatMessage({
          id: nameKey,
        })}
        {intl.formatMessage({
          id: 'productMeta.title',
        })}
      </title>
      <meta
        name="description"
        content={intl.formatMessage({
          id: descriptionKey,
        })}
      />
    </Helmet>
  );
};

export default Header;
